// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 141) return "static/chunks/a7e16ef1-8e34d2ee7e8cc448.js";
	if (chunkId === 743) return "static/chunks/743-9d6e0458bdcf2efe.js";
	if (chunkId === 587) return "static/chunks/587-ce9b646e9a1ecea0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"37":"49d38cdde2aa63c2","232":"8e02c1573841060c","415":"89b917c475fbc344","791":"5a04bc8d10fb89c7"}[chunkId] + ".js";
};